import React, { Component } from 'react';

export default class Lettre extends Component {



render() {
    return (<span className="formatLettresDefinition">{this.props.mot.map((l, i) => <span key={i} className={"lettresDefinition" + (l !== '' ? " animationLettre" : "")}>{l}</span>)}</span>)
}
}